<template>
  <div class="card" :class="widgetClasses">
    <div class="card-header border-0 pt-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label fw-bold fs-3 mb-1">Situações da NF-e</span>
      </h3>
      <div class="card-toolbar">
        <button
          type="button"
          class="btn btn-sm btn-icon btn-color-primary btn-active-light-primary"
          data-toggle="tooltip"
          data-placement="top"
          title="Atualizar"
          @click="this.atualizarGrafico()"
        >
          <span class="svg-icon svg-icon-2">
            <inline-svg src="media/icons/duotune/arrows/arr029.svg" />
          </span>
        </button>
      </div>
    </div>
    <div class="card-body">
      <apexchart
        v-if="!loading"
        type="pie"
        :options="options"
        :series="series"
        :height="chartHeight"
      ></apexchart>
      <div v-if="loading" v-bind:data-kt-indicator="loading ? 'on' : 'off'">
        <span class="indicator-progress">
          carregando...
          <span
            class="spinner-border spinner-border-sm align-middle ms-2"
          ></span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    widgetColor: { type: String, required: false, default: "danger" },
    widgetClasses: {
      type: String,
      required: false,
      default: "card-xl-stretch mb-xl-8",
    },
    chartHeight: { type: Number, required: false, default: 0 },
    chartColor: { type: String, required: false, default: "primary" },
  },
  methods: {
    async atualizarGrafico() {
      this.loading = true;
      this.series = [];
      let labels = [];
      try {
        let retFaturamentos = await this.$store.dispatch(
          "faturamento/getFaturamentoOData",
          "?$apply=groupby((status_nfe), aggregate($count as Count))&$select=status_nfe,Count"
        );

        if (retFaturamentos && retFaturamentos !== null) {
          labels.push(...retFaturamentos.map((item) => item.status_nfe));
          this.series.push(...retFaturamentos.map((item) => item.Count));
        }
        this.options.labels = labels;
      } catch (erro) {
        console.log(erro);
      }
      this.loading = false;
    },
  },
  async mounted() {
    await this.atualizarGrafico();
  },
  data() {
    return {
      loading: false,
      baseColor: "",
      series: [],
      options: {
        chart: {
          width: "380",
          type: "pie",
        },
        labels: [],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: "280",
              },
            },
          },
        ],
      },
    };
  },
};
</script>

<style lang="scss" scoped></style>
